document.addEventListener("alpine:init", () => {
    Alpine.data("scrollProgressBar", () => ({
        progress: 0,
        bar: null,
        init() {
            document.addEventListener("scroll", function (e) {
                this.winScroll =
                    document.body.scrollTop ||
                    document.documentElement.scrollTop;
                this.height =
                    document.documentElement.scrollHeight -
                    document.documentElement.clientHeight;
                this.scrolled = (this.winScroll / this.height) * 100;
                document.querySelector("#progressBar").style.width =
                    100 - this.scrolled + "%";
            });
        },
    }));
});
